<template>
  <div>
    <!-- 利用規約 同意アクション -->
    <TheDemandTerms v-model:turmCheckToggle="turmCheckToggle"/>

    <!-- エリア制限トグルボタン stg/devのみ表示 -->
    <areaValidationToggle v-if="isNotProd" v-model:toggle="areaValidationToggle"/>

    <demandActionButton
      :disabled="!turmCheckToggle"
      page="3"
      button1String="戻る"
      :button1Action="backToPreviousPage"
      button2String="予約内容の確認 ＞"
      :button2Action="actionMethods"
    />
    <!-- ローディングダイアログ -->
    <DialogLoading ref="DialogLoading" />
    
    <!-- エラーダイアログ -->
    <DialogErrorTentativeReservation ref="DialogErrorTentativeReservation" :errorCode="errorCode" />

    <DialogError ref="DialogErrorOutsideArea" :errorTitle="errorTitle" :errorSubTitle="errorSubTitle" />
  </div>
</template>

<script>
import { ref } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import API from "@/API";
import moment from "@/services/moment";
import geolocationService from "@/services/geolocation";

export default {
  name: "TheDemandActionButton3",
  props:{
    selectedService:{
      type: Object,
      require: true
    },
    seatCount:{
      type: Object,
      require: true
    },
    paymentMethods:{
      typr: Array,
      require: true
    }
  },
  setup(props) {
    const store = useStore();
    const router = useRouter();

    // 利用規約フラグ
    const turmCheckToggle = ref(false)

    const DialogLoading = ref(null);

    // 仮予約エラーダイアログ
    const DialogErrorTentativeReservation = ref()
    const errorCode = ref(null)

    // GEOlocationエラーダイアログ
    const DialogErrorOutsideArea = ref()
    const errorTitle = ref(null)
    const errorSubTitle = ref(null)


    // エリア制限用変数
    const isNotProd = process.env.VUE_APP_ENV !== "production";
    const areaValidationToggle = ref(false)

    // "予約内容の確認"ボタンのアクション関数
    const actionMethods = async() =>{
      DialogLoading.value.openDialog();

      // 範囲内外判定トグルが立っていたら現在地取得して、エリアの緯度経度と計算
      if(areaValidationToggle.value){
        try {

          // 現在地が引数のエリア内かの判定
          // const isInArea = await geolocationService.isInsideArea(props.selectedService.info.availableReservationCoordinates[1], props.selectedService.info.availableReservationCoordinates[3])

          // テスト用に宮ヶ瀬ダム近辺の緯度経度を引数に渡す。 (データ投入後削除予定)
          const isInArea = await geolocationService.isInsideArea({lat: "35.45921165202958", lng: "139.16716962899326"}, {lat: "35.53792063989951", lng: "139.24579781805278"})

          // 範囲外であればエラーハンドリング
          if (!isInArea) {
            // 仮予約可能エリア外のためエラー            
            openDialogErrorOutsideArea("範囲外", "現在地は範囲外です。")
            return false
          }
        } catch (err) {
          console.log('err :>> ', err);
          // 端末の設定によるエラーダイアログの表示
          if(err.message=="User denied Geolocation"){
            // 端末の設定によって現在地の取得ができない
            openDialogErrorOutsideArea("現在地の取得ができません", "端末の設定からEmotアプリでの現在地取得サービスの利用を許可してください。")
          } else {
            openDialogErrorOutsideArea("現在地の取得ができません", err.message)
          }
          return false
        }
      }

      // 仮予約API
      if(await postEbusTentativeReservation()){
        // 次ページへ
        await gotoBooking4()
      }
    }

    // APIを整えてPOST仮予約
    const postEbusTentativeReservation = async() =>{
        try {
          // pickUpTimeが今すぐの場合は現在時刻に1分1秒を追加
          if(store.getters["demand/pickUpTime"] == 'current'){
            var current = moment(new Date()).add(1, "m").add(1, "s").format("YYYY-MM-DDTHH:mm:ssZ");
          }

          const apiParams = {
            serviceAreaId: props.selectedService.service_area_id,
            pickUpBusstopId:store.getters["demand/pickUpBusstopId"],
            dropOffBusstopId: store.getters["demand/dropOffBusstopId"],
            seatCount: props.seatCount,
            paymentMethods: props.paymentMethods,
            pickUpTime: current,
            wheelchairCount: 0,
            lang: "ja",
          };

          await API.postEbusTentativeReservation(apiParams)
          await store.commit("demand/setPaymentMethods", props.paymentMethods);
          return true
        } catch (err) {
          console.log('err :>> ', err);
          // エラーコードによってダイアログに表示する文字列の変更
          errorCode.value = err.response.data.message
          DialogLoading.value.closeDialog();
          DialogErrorTentativeReservation.value.openDialog()
          return false
        }
    }

    // 次ページへ
    const gotoBooking4 = async() =>{
      router.push({
        name: "DemandEbusBooking4",
      });
    }

    // エラーダイアログのコントロール
    const openDialogErrorOutsideArea = (title, subTitle) =>{
      errorTitle.value = title
      errorSubTitle.value = subTitle
      DialogLoading.value.closeDialog();
      DialogErrorOutsideArea.value.openDialog();
    }

    return{
      turmCheckToggle,
      actionMethods,
      DialogLoading,

      DialogErrorTentativeReservation,
      errorCode,

      DialogErrorOutsideArea,
      errorTitle,
      errorSubTitle,

      isNotProd,
      areaValidationToggle
    }
  }
};
</script>
